/**
 * Does this press of play start a NEW playback (2026-10-20)? Every playback is logged, replays
 * included, so this decides what counts as one: the first play, a play after the recording
 * finished, or a play after going back to the start of something already well under way. A
 * pause and resume is the same playback, not another one.
 */
/**
 * Time heard between two position updates (2026-10-21). Only small forward steps count: a jump
 * forward is a seek, a step backwards is a seek or a restart, and neither is listening.
 */
export function heardBetween(previous: number, now: number): number {
  const d = now - previous;
  return d > 0 && d <= 2 ? d : 0;
}

export function isNewPlayback(state: { inProgress: boolean; furthest: number }, at: number): boolean {
  return !state.inProgress || (at < 1 && state.furthest >= 5);
}
